import "core-js/modules/es.array.includes.js";
import { ref, onMounted, onUnmounted, unref } from "vue";
//Note: In case we are using a screen reader (NVDA), this controller won't trigger normally since there are some key combinations reserved!
export var useKeyboardController = props => {
  var {
    isDropdownOpen,
    disableSpaceHandler
  } = props;
  var activeIdx = ref(-1);
  var selectedIdx = ref(-1);
  var onKeyDownHandler = e => {
    var ARROW_UP_KEY = "ArrowUp";
    var ARROW_DOWN_KEY = "ArrowDown";
    var ENTER_KEY = "Enter";
    var ESCAPE_KEY = "Escape";
    var SPACE_KEY = " ";
    var PAGE_UP_KEY = "PageUp";
    var HOME_KEY = "Home";
    var PAGE_DOWN_KEY = "PageDown";
    var END_KEY = "End";
    if (!isDropdownOpen.value || ![ARROW_UP_KEY, ARROW_DOWN_KEY, ENTER_KEY, ESCAPE_KEY, SPACE_KEY, PAGE_UP_KEY, HOME_KEY, PAGE_DOWN_KEY, END_KEY].includes(e.key)) return;
    var optionsLength = unref(props.optionsLength);
    if (e.key === ARROW_UP_KEY) {
      activeIdx.value = activeIdx.value === 0 ? optionsLength - 1 : activeIdx.value - 1;
    } else if (e.key === ARROW_DOWN_KEY) {
      activeIdx.value = (activeIdx.value + 1) % optionsLength;
    } else if (e.key === ENTER_KEY || e.key === SPACE_KEY) {
      if (e.key === SPACE_KEY && disableSpaceHandler) return;
      selectedIdx.value = activeIdx.value;
      //Closing the dropdown
      isDropdownOpen.value = false;
    } else if (e.key === ESCAPE_KEY) {
      activeIdx.value = selectedIdx.value;
      //Closing the dropdown
      isDropdownOpen.value = false;
    } else if (e.key === PAGE_UP_KEY || e.key === HOME_KEY) {
      //Returning to the first element of the options
      activeIdx.value = 0;
    } else if (e.key === PAGE_DOWN_KEY || e.key === END_KEY) {
      //Going to the last element of the options
      activeIdx.value = optionsLength - 1;
    }
    /* We do not want to scroll with the arrows */
    e.stopPropagation();
    e.preventDefault();
  };
  onMounted(() => {
    document.addEventListener("keydown", onKeyDownHandler);
  });
  onUnmounted(() => {
    document.removeEventListener("keydown", onKeyDownHandler);
  });
  return {
    activeIdx,
    selectedIdx
  };
};